import React, { Component } from 'react';
import { Modal,Form,Row,Col,DatePicker } from 'antd';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import messager from '../../ui/messager';
import MemberSelect from '../../barrier/MemberSelect';


const fields = [ 
{
    "text": "批量车公司",
    "field": "projectId",
    select:true,
    rules: [
        { required: true, message: '批量车公司需要选择!' }
    ]
}
,{
    "text": "结算日期",
    "field": "earlyBillDate",
    Date: true
}
];


class BatchVehicleBillEarlyForm extends Component {
    state = {
        loadingVisible: false
    }
    save = () => {
        const form = this.props.form;
        this.setState({ loadingVisible: true });
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["earlyBillDate"]=values["earlyBillDate"].format("YYYY-MM-DD")
            http.post({
                url: '/barrier/batchVehicleBill/early',
                data: values,
                success: (res) => {
                    this.setState({ loadingVisible: false });
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules
                        })(
                            item.select ?
                            <MemberSelect style={{ width: "100%" }} allowClear={true} />
                            :<DatePicker style={{ width: '100%' }} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="批量车公司编辑"
                width={500}
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.createDom(fields)}</Row>
                </Form>
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </Modal>
        );
    }
}

const BatchVehicleBillEarly = Form.create()(BatchVehicleBillEarlyForm);

export default BatchVehicleBillEarly;